/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserCheck} from '@fortawesome/pro-duotone-svg-icons';

const AssignedToIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserCheck} {...props} />
);

export default AssignedToIcon;
